import { MouseEvent } from "react";
import { cx } from "../../../../utils/classnames";
import { IMultiplePills } from "../Select.types";
import ExtendsList from "./ExtendsList";
import Pill from "./Pill";

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const MultiplePills = <T, D extends unknown>({
  extendsList,
  selected,
  disabled,
  getOptionLabel,
  onSelectedItemChange,
  onToggleClick
}: IMultiplePills<T, D>) => {
  // Clicking the pills overlay (a chip label or empty area) routes to the dropdown toggle, so the
  // control opens even when pills cover the whole input in a narrow cell. The chip remove button
  // (Pill) and the "+N" badge (ExtendsList) stopPropagation themselves, so they keep their own
  // behaviour and never also toggle the main dropdown.
  const onContainerClick = (e: MouseEvent<HTMLDivElement>) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    onToggleClick?.(e);
  };
  return (
    <div
      className={cx([
        "h-full w-full flex justify-center items-center gap-x-2 z-20",
        disabled ? "" : "pointer-events-auto"
      ])}
      onClick={onContainerClick}
    >
      {selected?.map((el) => (
        <Pill
          item={el}
          key={JSON.stringify(el)}
          disabled={disabled}
          getOptionLabel={getOptionLabel}
          onSelectedItemChange={onSelectedItemChange}
        />
      ))}
      {extendsList.length ? (
        <ExtendsList
          extendsList={extendsList}
          disabled={disabled}
          getOptionLabel={getOptionLabel}
          onSelectedItemChange={onSelectedItemChange}
        />
      ) : null}
    </div>
  );
};

export default MultiplePills;
